import { render, staticRenderFns } from "./JitsiIframe.vue?vue&type=template&id=56c34eb7&scoped=true&"
import script from "./JitsiIframe.vue?vue&type=script&lang=js&"
export * from "./JitsiIframe.vue?vue&type=script&lang=js&"
import style0 from "./JitsiIframe.vue?vue&type=style&index=0&id=56c34eb7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c34eb7",
  null
  
)

export default component.exports